<style scoped lang="css">
    #register {
        height: 100%;
        width: 100%;
        position: absolute;
        top: 0;
        left: 0;
        content: "";
        z-index: 0;
    }
</style>
<template>
    <v-app id="register" key="register">
        <v-content>
            <v-container fluid fill-height>
                <v-layout align-center justify-center>
                    <v-flex xs12 sm6 md6 lg6 xl6>
                        <v-layout align-center justify-center v-if="show=='role'">
                            <v-flex xs12 sm8 md8 lg8 xl8 style="text-align: center">
                                <img src="/login/logo_white_blue.png" :alt="$t('lang.header.title')" class="hand" width="" height="120" @click="toLandingPage"/>
                                <div>
                                    <div>
                                        <div class="layout column align-center">
                                            <div class="flex my-4 title primaryColor"
                                                 style="font-size: 20px;line-height: 100px">
                                                <div style="margin-bottom: 7px">
                                                    {{ $t('lang.common.registerTitle') }}
                                                </div>
                                                <div>
                                                    {{ $t('lang.common.registerDescription') }}
                                                </div>
                                            </div>
                                        </div>
                                        <div>
                                            Chọn vai trò
                                        </div>
                                        <div>
                                            <div class="choice" @click="studentSelect">
                                                <img src="/login/student.png" width="80px" height="80px"/>
                                                Bạn Là Học Viên
                                            </div>
                                            <div class="choice" @click="teacherSelect">
                                                <img src="/login/teacher.png" width="80px" height="80px"/>
                                                Bạn Là Giáo Viên
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div style="margin-top: 20px">
                                    Bạn đã có tài khoản? <a class="primaryColor" href="/#/login">Đăng nhập</a>
                                </div>
                            </v-flex>
                        </v-layout>
                        <v-layout align-center justify-center v-else-if="show=='phone'">
                            <v-flex xs12 sm10 md10 lg10 xl10 style="text-align: center">
                                <img src="/login/logo_white_blue.png" :alt="$t('lang.header.title')" class="hand" width="" height="120" @click="toLandingPage"/>
                                <v-card class="elevation-1 pa-3">
                                    <v-card-text>
                                        <div class="layout column align-center">
                                            <div class="flex my-4" style="font-size: 20px">
                                                {{ $t('lang.common.registerTitle') }}<br/>
                                                {{ $t('lang.common.registerDescription') }}
                                            </div>
                                        </div>
                                        <div>
                                            <a class="btn facebook mt10  mb10" @click="facebookRegister">
                                                <i class="fa fa-facebook"></i> Facebook
                                            </a>
                                            <a class="btn google mt10 mb10" @click="googleRegister">
                                                <i class="fa fa-google"></i> Google
                                            </a>
                                        </div>
                                        <v-form @keyup.enter.native="registerPhone" ref="phoneForm">
                                            <v-text-field append-icon="phone" v-validate="'required'"
                                                          name="phone"
                                                          key="registerPhone"
                                                          :label="$t('lang.user.phone')" type="text"
                                                          v-model="register.phone"
                                                          :error-messages="errors.first('phone')"
                                                          :data-vv-as="$t('lang.user.phone')"
                                            ></v-text-field>
                                            <v-text-field append-icon="email" v-validate="'required|email'"
                                                          key="registerEmail"
                                                          :label="$t('lang.user.email')" type="text"
                                                          v-model="register.email"
                                                          name="email"
                                                          :error-messages="errors.first('email')"
                                                          :data-vv-as="$t('lang.user.email')"
                                            ></v-text-field>
                                            <!--v-text-field style="display: none"></v-text-field-->
                                        </v-form>
                                    </v-card-text>
                                    <v-card-actions>
                                        <!--lang-switcher></lang-switcher-->
                                        <v-spacer></v-spacer>
                                        <v-btn dark class="yoprimary" @click="registerPhone" width="200">
                                            {{ $t('lang.common.register') }}
                                        </v-btn>
                                    </v-card-actions>
                                </v-card>
                                <div style="margin-top: 20px">
                                    Bạn đã có tài khoản? <a class="primaryColor" href="/#/login">Đăng nhập</a>
                                </div>
                            </v-flex>
                        </v-layout>
                        <v-layout align-center justify-center v-else-if="show=='detail'">
                            <v-flex xs12 sm10 md10 lg10 xl10 style="text-align: center">
                                <img src="/login/logo_white_blue.png" :alt="$t('lang.header.title')" class="hand" width="" height="120" @click="toLandingPage"/>
                                <v-card class="elevation-1 pa-3">
                                    <v-card-text style="text-align: center">
                                        <div class="layout column align-center">
                                            <div class="flex my-4" style="font-size: 20px" v-if="register.role==1">
                                                Đăng ký tài khoản <label class="primaryColor" href="#">GIÁO VIÊN</label>
                                                <br/>
                                                Để tạo & quản lý lớp học của mình trên Yoclass!
                                            </div>
                                            <div class="flex my-4" style="font-size: 20px" v-else>
                                                Đăng ký tài khoản <label class="primaryColor" href="#">HỌC VIÊN</label>
                                                <br/>
                                                Để tham gia các lớp học trên Yoclass!
                                            </div>
                                        </div>
                                        <v-form @keyup.enter.native="registerProfile">
                                            <!--img :src="register.avatar" width="50px" height="50px" style="border-radius: 50px"/-->
                                            <!--v-text-field append-icon="phone" v-validate="'required'"
                                                          key="phone"
                                                          :label="$t('lang.user.phone')" type="text"
                                                          v-model="register.phone"
                                                          name="phone"
                                                          :disabled="register.accountType=='phone'"
                                                          :error-messages="errors.first('phone')"
                                                          :data-vv-as="$t('lang.user.phone')"
                                            ></v-text-field-->
                                            <v-text-field v-validate="'required'"
                                                          name="userName"
                                                          key="userName"
                                                          readonly
                                                          label="Tài khoản"
                                                          type="text" v-model="register.userName"
                                                          data-vv-as="Tài khoản"
                                                          :error-messages="errors.first('userName')"
                                            >
                                                <template slot="append">
                                                    <a class="primaryColor" @click="changeAccount">Thay đổi</a>
                                                </template>

                                            </v-text-field>
                                            <v-text-field append-icon="lock" v-if="register.accountType=='phone'"
                                                          v-validate="'required|min:8'"
                                                          :label="$t('lang.user.password')" type="password"
                                                          v-model="register.password" ref="password"
                                                          name="password"
                                                          key="password"
                                                          :error-messages="errors.first('password')"
                                                          :data-vv-as="$t('lang.user.password')"
                                            ></v-text-field>
                                            <v-text-field append-icon="lock" v-if="register.accountType=='phone'"
                                                          v-validate="'required|confirmed:password'"
                                                          :label="$t('lang.user.retypePassword')" type="password"
                                                          v-model="register.confirmPassword"
                                                          name="confirmPassword"
                                                          key="confirmPassword"
                                                          :error-messages="errors.first('confirmPassword')"
                                                          :data-vv-as="$t('lang.user.retypePassword')"
                                            ></v-text-field>
                                            <v-text-field append-icon="person" v-validate="'required'"
                                                          key="fullName"
                                                          :label="$t('lang.user.fullName')" type="text"
                                                          v-model="register.fullName"
                                                          name="fullName"
                                                          :error-messages="errors.first('fullName')"
                                                          :data-vv-as="$t('lang.user.fullName')"
                                            ></v-text-field>
                                            <i-datepicker v-model="register.birthday"
                                                          :label="$t('lang.user.birthday')"
                                                          v-validate="'required|date_before_now'"
                                                          name="birthday"
                                                          key="birthday"
                                                          :error-messages="errors.first('birthday')"
                                                          :data-vv-as="$t('lang.user.birthday')"
                                            />
                                            <v-radio-group v-model="register.gender"
                                                           v-validate="'required'"
                                                           name="gender"
                                                           key="gender"
                                                           :error-messages="errors.first('gender')"
                                                           data-vv-as="Giới tính"
                                                           label="Giới tính">
                                                <v-radio
                                                        key="maleGender"
                                                        label="Nam"
                                                        :value="true"
                                                ></v-radio>
                                                <v-radio
                                                        key="femaleGender"
                                                        label="Nữ"
                                                        :value="false"
                                                ></v-radio>
                                            </v-radio-group>
                                        </v-form>
                                    </v-card-text>
                                    <v-card-actions>
                                        <!--lang-switcher></lang-switcher-->
                                        <div style="width: 100%;text-align: center">
                                            <v-btn class="yoprimary" @click="registerProfile" dark>
                                                {{ $t('lang.common.continue') }}
                                            </v-btn>
                                            <br/>
                                            <v-btn flat @click="toLandingPage" class="primaryColor">
                                                Hủy
                                            </v-btn>
                                        </div>
                                    </v-card-actions>
                                </v-card>
                            </v-flex>
                        </v-layout>
                        <v-layout align-center justify-center v-else-if="show=='validate'">
                            <v-flex xs12 sm10 md10 lg10 xl10 style="text-align: center">
                                <img src="/login/logo_white_blue.png" :alt="$t('lang.header.title')" class="hand" width="" height="120" @click="toLandingPage"/>
                                <v-card class="elevation-1 pa-3">
                                    <v-card-text>
                                        <div class="layout column align-center">
                                            <div style="font-size: 20px" class="flex my-4">
                                                Hãy nhập mã xác thực đã được gửi đến
                                                {{register.userName==register.email?"Email":"SĐT"}} của bạn!
                                            </div>
                                        </div>
                                        <v-form @submit.prevent="verify">
                                            <v-text-field append-icon="lock" v-validate="'required'"
                                                          key="verifyCode"
                                                          :label="$t('lang.user.verifyCode')"
                                                          name="verifyCode" type="text"
                                                          v-model="register.verify"
                                                          :data-vv-as="$t('lang.user.verifyCode')"
                                                          :error-messages="errors.first('verifyCode')"
                                            >
                                                <template slot="append">
                                                    <a class="primaryColor" style="text-decoration: underline"
                                                       @click="resend">Gửi
                                                        lại</a>
                                                </template>

                                            </v-text-field>
                                        </v-form>
                                    </v-card-text>
                                    <v-card-actions>
                                        <!--lang-switcher></lang-switcher-->
                                        <div style="width: 100%;text-align: right">
                                            <v-btn flat class="primaryColor" @click="cancelVerify">
                                                <div style="text-decoration: underline">Cập nhật thông tin</div>
                                            </v-btn>
                                            <v-btn class="yoprimary" dark @click="verify">
                                                {{ $t('lang.common.continue') }}
                                            </v-btn>
                                        </div>
                                    </v-card-actions>
                                </v-card>
                            </v-flex>
                        </v-layout>
                        <v-layout align-center justify-center v-else-if="show=='validate_2'">
                            <v-flex xs12 sm10 md10 lg10 xl10 style="text-align: center">
                                <img src="/login/logo_white_blue.png" :alt="$t('lang.header.title')" class="hand" width="" height="120" @click="toLandingPage"/>
                                <v-card class="elevation-1 pa-3">
                                    <v-card-text>
                                        <div class="layout column align-center">
                                            <div style="font-size: 20px" class="flex my-4">
                                                Hãy nhập mã xác thực đã được gửi đến
                                                {{register.userName==register.email?"SĐT":"Email"}} của bạn!
                                            </div>
                                        </div>
                                        <v-form @submit.prevent="reVerify">
                                            <v-text-field append-icon="lock" v-validate="'required'"
                                                          key="reVerifyCode"
                                                          :label="$t('lang.user.verifyCode')"
                                                          name="reVerifyCode" type="text"
                                                          v-model="register.verify"
                                                          :data-vv-as="$t('lang.user.verifyCode')"
                                                          :error-messages="errors.first('reVerifyCode')"
                                            >
                                                <template slot="append">
                                                    <a class="primaryColor" style="text-decoration: underline"
                                                       @click="resendOther">Gửi
                                                        lại</a>
                                                </template>

                                            </v-text-field>
                                        </v-form>
                                    </v-card-text>
                                    <v-card-actions>
                                        <!--lang-switcher></lang-switcher-->
                                        <div style="width: 100%;text-align: right">
                                            <v-btn flat class="primaryColor" @click="cancelReverify">
                                                <div style="text-decoration: underline">Cập nhật thông tin</div>
                                            </v-btn>
                                            <v-btn class="yoprimary" dark @click="reVerify">
                                                {{ $t('lang.common.continue') }}
                                            </v-btn>
                                        </div>
                                    </v-card-actions>
                                </v-card>
                            </v-flex>
                        </v-layout>
                        <v-layout align-center justify-center v-else-if="show=='student_profile'">
                            <v-flex xs12 sm10 md10 lg10 xl10 style="text-align: center">
                                <img src="/login/logo_white_blue.png" :alt="$t('lang.header.title')" class="hand" width="" height="120" @click="toLandingPage"/>
                                <v-card class="elevation-1 pa-3">
                                    <v-card-text>
                                        <div class="layout column align-center">
                                            <div class="flex my-4" style="font-size: 20px">
                                                {{ register.fullName }} hãy bổ sung thông tin để hoàn tất đăng ký tài
                                                khoản
                                                Học
                                                viên!
                                            </div>
                                        </div>
                                        <v-form @keyup.enter.native="updateStudentProfile" ref="phoneForm">
                                            <v-layout>
                                                <v-flex>
                                                    <i-upload :label="$t('lang.teacher.avatar')"
                                                              v-model="register.avatarId"
                                                              file-type="avatar" :multifile="false"
                                                              key="avatarId"
                                                              name="avatarId"
                                                              :data-vv-as="$t('lang.teacher.avatar')"
                                                              :error-messages="errors.first('avatarId')"
                                                    />
                                                </v-flex>
                                            </v-layout>
                                            <v-layout>
                                                <v-flex xs11 sm11 md11 lg11 xl11>
                                                    <v-text-field type="text" :label="$t('lang.user.email') "
                                                                  v-model.trim="register.email"
                                                                  v-validate="'email'"
                                                                  :disabled="register.email == register.userName"
                                                                  name="email"
                                                                  maxLength="50"
                                                                  :data-vv-as="$t('lang.user.email')"
                                                                  :error-messages="errors.first('email')"/>
                                                    <v-text-field type="text" :label="$t('lang.user.phone')"
                                                                  v-model.trim="register.phone"
                                                                  v-validate="'phone'"
                                                                  name="phone"
                                                                  maxLength="50"
                                                                  :disabled="register.phone == register.userName"
                                                                  :data-vv-as="$t('lang.user.phone')"
                                                                  :error-messages="errors.first('phone')"/>
                                                    <v-text-field type="text" :label="$t('lang.user.yolearn')"
                                                                  v-model.trim="register.yolearn"
                                                                  name="yolearn"
                                                                  key="yolearn"
                                                                  maxLength="20"
                                                                  :data-vv-as="$t('lang.user.yolearn')"
                                                                  :error-messages="errors.first('yolearn')"/>
                                                    <v-text-field type="text" :label="$t('lang.user.zalo')"
                                                                  v-model.trim="register.zalo"
                                                                  name="zalo"
                                                                  key="zalo"
                                                                  maxLength="50"
                                                                  :data-vv-as="$t('lang.user.zalo')"
                                                                  :error-messages="errors.first('zalo')"/>
                                                </v-flex>
                                                <v-flex xs1 sm1 md1 lg1 xl1 style="text-align: right">
                                                    <v-checkbox name="notifyEmail" key="notifyEmail"
                                                                v-model="register.notifyEmail"/>
                                                    <v-checkbox name="notifySMS" key="notifySMS"
                                                                v-model="register.notifySms"/>
                                                    <v-checkbox name="notifyYoLearn" key="notifyYoLearn"
                                                                v-model="register.notifyYolearn"/>
                                                    <v-checkbox name="notifyZalo" key="notifyZalo"
                                                                v-model="register.notifyZalo"/>
                                                </v-flex>
                                            </v-layout>
                                        </v-form>
                                    </v-card-text>
                                    <v-card-actions>
                                        <!--lang-switcher></lang-switcher-->
                                        <v-spacer></v-spacer>
                                        <v-btn dark class="yoprimary" @click="updateStudentProfile" width="200">
                                            {{ $t('lang.common.register') }}
                                        </v-btn>
                                        <v-btn @click="toLoginPage" width="200">
                                            Bỏ qua
                                        </v-btn>
                                    </v-card-actions>
                                </v-card>
                                <div style="margin-top: 20px">
                                    Bạn đã có tài khoản? <a class="primaryColor" href="/#/login">Đăng nhập</a>
                                </div>
                            </v-flex>
                        </v-layout>
                        <v-layout align-center justify-center v-else>
                            <v-flex xs12 sm10 md10 lg10 xl10 style="text-align: center;">
                                <img src="/login/logo_white_blue.png" :alt="$t('lang.header.title')" class="hand" width="" height="120" @click="toLandingPage"/>
                                <v-card class="elevation-1 pa-3">
                                    <v-card-text style="text-align: center">
                                        <div class="layout column align-center">
                                            <div class="flex my-4" style="font-size: 20px">
                                                {{register.gender?"Thầy":"Cô"}} {{ register.fullName }} hãy bổ sung
                                                thông
                                                tin để
                                                hoàn tất đăng ký tài khoản Giáo
                                                viên!
                                            </div>
                                        </div>
                                        <v-form @keyup.enter.native="updateTeacherProfile" ref="teacherProfile">
                                            <i-upload :label="$t('lang.teacher.avatar')"
                                                      v-model="profile.avatarId"
                                                      file-type="avatar" :multifile="false"
                                                      key="avatarId"
                                                      name="avatarId"
                                                      :data-vv-as="$t('lang.teacher.avatar')"
                                                      :error-messages="errors.first('avatarId')"
                                            />
                                            <v-text-field type="text" :label="$t('lang.user.email') "
                                                          v-model.trim="profile.email"
                                                          v-validate="'required|email'"
                                                          name="email"
                                                          maxLength="50" :disabled="register.userName == register.email"
                                                          :data-vv-as="$t('lang.user.email')"
                                                          :error-messages="errors.first('email')"/>
                                            <v-text-field type="text" :label="$t('lang.user.phone')"
                                                          v-model.trim="profile.phone"
                                                          v-validate="'required|phone'"
                                                          name="phone"
                                                          maxLength="50"
                                                          :disabled="register.userName == register.phone"
                                                          :data-vv-as="$t('lang.user.phone')"
                                                          :error-messages="errors.first('phone')"/>
                                            <v-select v-validate="'required'"
                                                      label="Nơi công tác"
                                                      v-model="profile.provinceId"
                                                      name="province"
                                                      key="province"
                                                      data-vv-as="Nơi công tác"
                                                      :items="lstProvice"
                                                      @change="getProvinceName"
                                                      item-text="categoryName"
                                                      item-value="categoryId"
                                                      :error-messages="errors.first('province')"
                                            ></v-select>
                                            <!--v-select v-validate="'required'"
                                                      label="Bạn là"
                                                      v-model="profile.groupId"
                                                      name="teacherGroup"
                                                      key="teacherGroup"
                                                      data-vv-as="Nơi sinh sống"
                                                      :items="lstGroup"
                                                      @change="getGroupName"
                                                      item-text="categoryName"
                                                      item-value="categoryId"
                                                      :error-messages="errors.first('teacherGroup')"
                                            ></v-select-->
                                            <v-text-field append-icon="room" v-validate="'required'"
                                                          :label="$t('lang.teacher.workingAt')" type="text"
                                                          v-model="profile.workingAt"
                                                          name="workingAt"
                                                          key="workingAt"
                                                          :data-vv-as="$t('lang.teacher.workingAt')"
                                                          :error-messages="errors.first('workingAt')"

                                            />
                                        </v-form>
                                    </v-card-text>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn class="yoprimary" dark @click="updateTeacherProfile">
                                            {{ $t('lang.common.register') }}
                                        </v-btn>
                                        <v-btn color="cancel" @click="cancel">
                                            {{ $t('lang.common.cancel') }}
                                        </v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                    <v-flex xs12 sm6 md6 lg6 xl6 class="hideInMobile">
                        <img src="/login/class_2.png"/>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-content>
    </v-app>
</template>

<script async defer src="https://connect.facebook.net/en_US/sdk.js"></script>

<script>
    import LangSwitcher from "../../components/header/LangSwitcher";
    import {message} from '../../services';
    import {alert} from '../../store/alert.module';
    import IDatepicker from "../../components/form/DatePicker";
    import axios from "axios"
    import IUpload from "../../components/form/Upload";
    import {router} from '@/router';
    import Validator from "../../../public/js/validator";

    var GoogleAuth;

    export default {
        components: {
            IUpload,
            IDatepicker,
            LangSwitcher
        },
        watch: {
            '$route'(to, from) {
                ////console.log(to);
                ////console.log(from);
                let userName = to.params.username;
                if (userName != undefined && userName != null) {
                    this.register.userName = userName;
                }
            }
        },
        data() {
            return {
                username: '',
                password: '',
                show: "role",
                submitted: false,
                register: {},
                profile: {},
                lstProvice: [],
                lstGroup: [],
                roles: [
                    {
                        text: this.$t('lang.user.teacher'),
                        value: 1
                    },
                    {
                        text: this.$t('lang.user.pupil'),
                        value: 2
                    },
                ]
            }
        },
        mounted() {
            if (this.$store.state.auth.loggedIn) {
                this.$route.push('/HomePage');
            } else {
                this.register = {};
                let userName = this.$route.params.username;
                if (userName != undefined && userName != null) {
                    this.register.userName = userName;
                }
                //console.log(this.register);
                let v = this;
                //
                // init facebook
                //
                window.fbAsyncInit = function () {
                    FB.init({
                        appId: '998333920543921',
                        cookie: true,
                        xfbml: true,
                        version: 'v5.0'
                    });

                    //FB.AppEvents.logPageView();

                };

                (function (d, s, id) {
                    var js, fjs = d.getElementsByTagName(s)[0];
                    if (d.getElementById(id)) {
                        return;
                    }
                    js = d.createElement(s);
                    js.id = id;
                    js.src = "https://connect.facebook.net/en_US/sdk.js";
                    fjs.parentNode.insertBefore(js, fjs);
                }(document, 'script', 'facebook-jssdk'));
            }

        },
        methods: {
            clear: function () {
                this.show = "role";
                this.register = {};
                this.profile = {};
            },

            changeAccount: function () {
                //this.$router.push("/login");
                this.clear();
                this.$router.go(-1);
            },

            teacherSelect: function () {
                this.register.role = 1;
                this.register.accountType = "phone";
                this.show = "detail";
            },

            studentSelect: function () {
                this.register.role = 2;
                this.register.accountType = "phone";
                this.show = "detail";
            },

            verify() {
                this.$validator.validate().then(valid => {
                    //console.log(valid);
                    if (!valid) {
                        message.error(this.$t("lang.common.validate_fail"));
                        return;
                    }
                    //this.register.accountType = "phone";
                    axios.post(process.env.VUE_APP_API_URL + "/register/verify", this.register).then(
                        data => {
                            if (data.success) {
                                if (this.register.role == 1) {
                                    this.getCategoryData();
                                    this.profile.email = this.register.email;
                                    this.profile.phone = this.register.phone;
                                    this.profile.teacherName = this.register.fullName;
                                    this.show = "teacher_profile";
                                } else {
                                    /*
                                                                        if (this.register.userName == this.register.email) {
                                                                            this.register.notifyEmail = true;
                                                                        } else if (this.register.userName == this.register.phone) {
                                                                            this.register.notifySms = true;
                                                                        }
                                                                        this.show = "student_profile";
                                    */
                                    this.login();

                                }
                                //message.error("Mã xác thực không đúng");
                            } else {
                                message.error("Mã xác thực chưa đúng");
                            }
                        },
                        error => {
                            //console.log(error);
                        }
                    );
                });
            },

            cancelVerify: function () {
                this.show = "detail";
            },

            reVerify() {
                this.$validator.validate().then(valid => {
                    //console.log(valid);
                    if (!valid) {
                        message.error(this.$t("lang.common.validate_fail"));
                        return;
                    }
                    //this.register.accountType = "phone";
                    axios.post(process.env.VUE_APP_API_URL + "/register/reVerify", this.register).then(
                        data => {
                            if (data.success) {
                                this.login();
                            } else {
                                message.error(this.$t(data.description));
                            }
                        },
                        error => {
                            //console.log(error);
                        }
                    );
                });
            },

            cancelReverify: function () {
                if (this.register.role == 1) {
                    this.show = "teacher_profile"
                } else {
                    this.show = "student_profile";
                }
                //this.backToLoginPage();

            },

            registerPhone: function () {
                this.register.accountType = "phone";
                this.$validator.validate().then(valid => {
                    //console.log(valid);
                    if (!valid) {
                        message.error(this.$t("lang.common.validate_fail"));
                        return;
                    }
                    this.register.accountType = "phone";
                    this.register.id = this.register.phone;
                    this.register.userName = this.register.phone;
                    axios.post(process.env.VUE_APP_API_URL + "/register/sendVerify", this.register).then(
                        data => {
                            if (data.success) {
                                this.register.verify = "";
                                this.show = "validate";
                            } else {
                                message.error(this.$t(data.description));
                            }
                        },
                        error => {
                            //console.log(error);
                        }
                    );
                });
            },

            resend: function () {
                axios.post(process.env.VUE_APP_API_URL + "/register/sendVerify", this.register).then(
                    data => {
                        if (data.success) {
                            message.success("Gửi lại thành công");
                        } else {
                            message.error(this.$t(data.description));
                        }
                    },
                    error => {
                        //console.log(error);
                    }
                );
            },

            resendOther: function () {
                axios.post(process.env.VUE_APP_API_URL + "/register/sendVerifyOther", this.register).then(
                    data => {
                        if (data.success) {
                            message.success("Gửi lại thành công");
                        } else {
                            message.error(this.$t(data.description));
                        }
                    },
                    error => {
                        //console.log(error);
                    }
                );
            },

            registerProfile: function () {
                this.$validator.validate().then(valid => {
                    if (!valid) {
                        message.error(this.$t("lang.common.validate_fail"));
                        //console.log(this.$validator.errors);
                        return;
                    }
                    let validator = new Validator();
                    if (validator.validateEmail(this.register.userName)) {
                        this.register.email = this.register.userName;
                    } else if (validator.validatePhone(this.register.userName)) {
                        this.register.phone = this.register.userName;
                    } else {
                        message.error(this.$t("lang.common.validate_fail"));
                        return;
                    }
                    axios.post(process.env.VUE_APP_API_URL + "/register/sendProfile", this.register).then(
                        data => {
                            if (data.success) {
                                //message.success(this.$t(data.description));
                                this.show = "validate";
                                if (this.register.role == 1) {
                                    //
                                    // is teacher -> nead to update profile
                                    //
                                    this.register.userId = data.id;
                                    //this.show = "profile";
                                    this.profile.userId = data.id;
                                    this.profile.teacherName = this.register.fullName;
                                    this.profile.email = this.register.email;
                                } else {
                                    //this.show = "phone";
                                    this.register.userId = data.id;
                                    //this.profile = {};
                                    //router.push("/login");
                                }
                            } else {
                                message.error(this.$t(data.description));
                            }
                        },
                        error => {
                            //console.log(error);
                        }
                    );
                });

            },

            updateStudentProfile: function () {
                this.$validator.validate().then(valid => {
                    if (!valid) {
                        message.error(this.$t("lang.common.validate_fail"));
                        return;
                    }
                    let validator = new Validator();
                    if (validator.validateEmail(this.register.userName)) {
                        this.register.email = this.register.userName;
                    } else if (validator.validatePhone(this.register.userName)) {
                        this.register.phone = this.register.userName;
                    } else {
                        message.error(this.$t("lang.common.validate_fail"));
                        return;
                    }
                    axios.post(process.env.VUE_APP_API_URL + "/register/updateStudentProfile", this.register).then(
                        data => {
                            if (data.success) {
                                message.success(this.$t(data.description));
                                if ((this.register.userName == this.register.email && this.register.notifySMS)
                                    || (this.register.notifyEmail && this.register.userName == this.register.phone)) {
                                    this.show = "validate_2";
                                    this.register.verify = "";
                                } else {
                                    this.toLoginPage();
                                }
                            } else {
                                message.error(this.$t(data.description));
                            }
                        },
                        error => {
                            //console.log(error);
                        }
                    );
                });

            },

            updateTeacherProfile: function () {
                this.$validator.validate().then(valid => {
                    if (!valid) {
                        message.error(this.$t("lang.common.validate_fail"));
                        return;
                    }
                    axios.post(process.env.VUE_APP_API_URL + "/register/sendTeacherProfile", this.profile).then(
                        data => {
                            if (data.success) {
                                message.success(this.$t(data.description));
                                this.show = "validate_2";
                                this.register.verify = "";
                            } else {
                                message.error(this.$t(data.description));
                            }
                        },
                        error => {
                            //console.log(error);
                        }
                    );
                });
            },

            cancel: function () {
                //this.show = "phone";
                this.clear();
                this.$router.push("/LandingPage");
            },

            getFacebookInfo: function (author, vue) {
                FB.api('/me', 'get', {
                    access_token: author.authResponse.access_token,
                    fields: 'id,name,gender,address,birthday,email,languages'
                }, function (userInfo) {
                    userInfo.avatar = "https://graph.facebook.com/" + userInfo.id + "/picture?type=normal";
                    userInfo.accountType = "facebook";
                    userInfo.fullName = userInfo.name;
                    userInfo.userName = userInfo.id;
                    userInfo.birthday = null;
                    vue.register = userInfo;
                    vue.show = "detail";

                });

            },

            facebookRegister: function () {
                let v = this;
                FB.getLoginStatus(function (r) {
                    if (r.status === 'connected') {
                        v.getFacebookInfo(r, v);
                    } else {
                        FB.login(function (author) {
                            v.getFacebookInfo(author, v);
                        }, {scope: 'email'}); // which data to access from user profile
                    }
                });
            },

            googleRegister: function () {
                var auth2;
                var v = this;
                gapi.load('auth2', function () {
                    auth2 = gapi.auth2.init({
                        client_id: '98948171933-iutm4oq2i464cvhl5s24ecc6luvmvbbi.apps.googleusercontent.com',
                        fetch_basic_profile: true,
                        scope: 'profile'
                    });

                    // Sign the user in, and then retrieve their ID.
                    auth2.signIn().then(function () {
                        let userInfo = auth2.currentUser.get();
                        //console.log(userInfo);
                        let profile = userInfo.getBasicProfile();
                        //console.log(profile);
                        let user = {
                            id: profile.getId(),
                            userName: profile.getId(),
                            fullName: profile.getName(),
                            avatar: profile.getImageUrl(),
                            email: profile.getEmail(),
                            birthday: null,
                            accountType: "google"
                        };
                        v.register = user;
                        v.show = "detail";
                    });
                });
            },

            toLandingPage: function () {
                this.show = "role";
                this.$router.push("/LandingPage");
            },

            toLoginPage: function () {
                //this.$router.push("/login/" + this.register.userName + "/" + this.register.password);
                this.show = "role";
                this.login();
            },

            login: function () {
                const {dispatch} = this.$store;
                let username = this.register.userName;
                let password = this.register.password;
                if (username && password) {
                    dispatch('auth/login', {cred: {username, password}, vm: this});
                }

            },

            backToLoginPage: function () {
                this.clear();
                this.$router.push("/login");
            },

            getCategoryData: function () {
                axios.post(process.env.VUE_APP_API_URL + "/category/listForSelect?type=PROVINCE").then(
                    data => {
                        this.lstProvice = data;
                    },
                    error => {

                    }
                ),
                    axios.post(process.env.VUE_APP_API_URL + "/category/listForSelect?type=TEACHER_GROUP").then(
                        data => {
                            this.lstGroup = data;
                        },
                        error => {

                        }
                    )
            },

            getProvinceName: function () {
                for (let i = 0; i < this.lstProvice.length; i++) {
                    if (this.lstProvice[i].categoryId == this.profile.provinceId) {
                        this.profile.provinceName = this.lstProvice[i].categoryName;
                        break;
                    }
                }
            },

            getGroupName: function () {
                for (let i = 0; i < this.lstGroup.length; i++) {
                    if (this.lstGroup[i].categoryId == this.profile.groupId) {
                        this.profile.groupName = this.lstGroup[i].categoryName;
                        break;
                    }
                }

            }
        }
    };
</script>
<style>
    .btn {
        margin-top: 10px;
        margin-bottom: 10px;
        margin-left: 10px;
        color: white;
        padding: 10px 20px;
        width: 45%;
        max-height: 40px;
        overflow: hidden;
        display: inline-block;
        border-radius: 5px;
    }

    .google {
        background-color: #dd4b39;
    }

    .facebook {
        background-color: #3b5998;
    }
</style>

